/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Login_Sign_Up_HintInputs */

const en_auth_login_sign_up_hint = /** @type {(inputs: Auth_Login_Sign_Up_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Don't have an account? Sign up`)
};

const es_auth_login_sign_up_hint = /** @type {(inputs: Auth_Login_Sign_Up_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No tienes cuenta? Registrate`)
};

/**
* | output |
* | --- |
* | "Don't have an account? Sign up" |
*
* @param {Auth_Login_Sign_Up_HintInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const auth_login_sign_up_hint = /** @type {((inputs?: Auth_Login_Sign_Up_HintInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Login_Sign_Up_HintInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_login_sign_up_hint(inputs)
	return es_auth_login_sign_up_hint(inputs)
});